import { NumericInput } from '@interstate/components/NumericInput';

import { useNetCashPayoutField } from './hooks/useNetCashPayoutField';

const NetCashPayoutField = () => {
    const { label, inputProps } = useNetCashPayoutField();

    return (
        <NumericInput
            label={label}
            {...inputProps}
            inputPrefix={'$'}
            allowDecimal={true}
            decimalMaxLength={2}
            decimalMinLength={0}
            size="sm"
            readOnly={true}
        />
    );
};

export default NetCashPayoutField;
